import { refreshPage } from "./helpers/refreshPage";

export default async function handleBasketEvent(event) {
  if (event === "orderCreated") {
    window.location.href = InpostIziJavsscriptWoocommerce.thank_you_url;
    return Promise.resolve(true);
  }

  if (event === "basketProductChanged") {
    refreshPage();
    return Promise.resolve(true);
  }

  if (event === "basketDeleted") {
    const isSingleProductPageBodyClass =
      document.body.classList.contains("single-product");
    const isSingleProductPage = document.querySelector(".izi-widget-product");
    if (!isSingleProductPageBodyClass && !isSingleProductPage) return;

    refreshPage();
    return Promise.resolve(true);
  }
}
